import { Box, Button, Modal, Paper, Typography } from '@mui/material'
import { Dispatch, MouseEvent, SetStateAction } from 'react'
import { useHelpText } from '../../../../api/texts/hooks'
import useStyle from '../styles/Step3.styles'

interface UserInforModalProps {
    modalOpen: boolean
    setModalOpen: Dispatch<SetStateAction<boolean>>
    informFunction: (e: MouseEvent<HTMLButtonElement>) => void
    textKey: string
}

export const UserInformModal = (props: UserInforModalProps) => {
    const { modalOpen, setModalOpen, informFunction, textKey } = props
    const classes = useStyle()
    const { data: text } = useHelpText(textKey)
    if (!text) return <></>

    const handleClose = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault()
        setModalOpen(false)
        informFunction(e)
    }

    return modalOpen ? (
        <Modal className={classes.informModal} open={modalOpen} onClose={() => setModalOpen(false)}>
            <Paper>
                <Box paddingBottom={1} paddingLeft={3} paddingRight={3}>
                    <Typography variant='h6' component='div'>
                        <p dangerouslySetInnerHTML={{ __html: text }}></p>
                    </Typography>
                </Box>
                <Box>
                    <Button variant='contained' size='large' onClick={handleClose}>
                        Beru na vědomí
                    </Button>
                </Box>
            </Paper>
        </Modal>
    ) : null
}
